var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 8.75H13.125C10 8.75 8.75 10 8.75 13.125V16.875C8.75 20 10 21.25 13.125 21.25H16.875C20 21.25 21.25 20 21.25 16.875V15.625",
    stroke: "#007ECB",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5257 9.38747L12.6007 14.3125C12.4132 14.5 12.2257 14.8687 12.1882 15.1375L11.9194 17.0187C11.8194 17.7 12.3007 18.175 12.9819 18.0812L14.8632 17.8125C15.1257 17.775 15.4944 17.5875 15.6882 17.4L20.6132 12.475C21.4632 11.625 21.8632 10.6375 20.6132 9.38747C19.3632 8.13747 18.3757 8.53747 17.5257 9.38747Z",
    stroke: "#007ECB",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8184 10.0938C17.2371 11.5875 18.4059 12.7563 19.9059 13.1813",
    stroke: "#007ECB",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.9dd615e7048338497e4141f1515642ce.svg";
export { ForwardRef as ReactComponent };